import { render } from "./PuzzleGame.vue?vue&type=template&id=7e4cca72&scoped=true"
import script from "./PuzzleGame.vue?vue&type=script&lang=js"
export * from "./PuzzleGame.vue?vue&type=script&lang=js"

import "./PuzzleGame.vue?vue&type=style&index=0&id=7e4cca72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4cca72"]])

export default __exports__